var _style, _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPandaLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 50 50",
    style: {
      enableBackground: "new 0 0 50 50"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M30.6,40.7c-0.2,1.2-0.4,2.2-0.7,3.3c-0.6,2.1-2.7,2.9-4.6,2.3c-2.3-0.7-4.2-2.1-6.1-3.5 c-1.6-1.1-3.5-1.6-5.5-1.8c-1.9-0.2-3.8-0.4-5.5-1.4c-1.5-0.9-1.9-2.4-1.3-4.1c1-2.3,2.3-4.3,4.1-6c2.9-2.8,6.1-5.1,10.1-6 c2.2-0.5,4.2-0.4,6.1,1c1.1,0.8,1.7,1.9,2.1,3.1c0.8,2.3,1.4,4.7,1.4,7.2C30.8,36.8,30.7,38.7,30.6,40.7z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M35.2,21.5c-1.5,0.7-2.9,1-4.5,0.6c-1.3-0.4-2.1-1.5-2.3-2.9c-0.4-3.1,0.9-5.6,2.9-7.8c1.2-1.4,2.6-2.5,4.4-3 c1.5-0.4,2.9-0.5,4,0.6c0.6,0.6,1.2,1.5,1.3,2.3c0.4,2.3-0.3,4.5-1.6,6.4C38.4,19.3,37.1,20.6,35.2,21.5z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M17.6,15.2c-0.2-1.5-0.4-2.9-0.4-4.3c0-2.3,0.6-4.3,2.1-6c1.7-2,5.1-1.9,6.8,0.5c0.9,1.2,1.3,2.7,1.3,4.2 c0,1.6,0,3.1-0.4,4.6c-0.4,1.7-1.4,3.2-2.9,4.2c-2,1.5-4.5,0.9-5.7-1.4C18.1,16.5,17.9,15.9,17.6,15.2z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M32.7,28.7c0.9-2.5,2.5-4.1,4.7-5.3c1.1-0.6,2.2-0.9,3.5-0.9c2.2,0,3.2,1.4,3.2,3.2c0,3.5-1.7,6.1-4.7,7.7 c-1.1,0.6-2.4,1-3.7,1.1c-1.6,0.2-2.9-0.7-3.2-2.6C32.3,30.8,32.6,29.8,32.7,28.7z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M7.1,21.8c-1-2.3-1.5-4.7-0.8-7.1c0.2-0.8,0.8-1.7,1.4-2.3c1-1,3-0.7,4.1,0c3.4,2.3,4.9,7.8,3.1,11.3 c-0.8,1.5-2.3,2.3-4.3,1.4C9,24.5,7.9,23.4,7.1,21.8z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPandaLogo);
export default __webpack_public_path__ + "static/media/panda_logo.7c078955a7ec768d5e522b004ebdcb3b.svg";
export { ForwardRef as ReactComponent };